import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

// core components
import cardStyle from "assets/jss/material-dashboard-react/components/cardStyle.jsx";

function Card({ ...props }) {
  const {
    classes,
    className,
    children,
    color,
    plain,
    profile,
    chart,
    style,
    theme,
    ...rest
  } = props;

  const isDarkTheme =
    (theme && theme.palette && theme.palette.type === "dark") ||
    (typeof window !== "undefined" &&
      window.localStorage &&
      window.localStorage.getItem("themeMode") === "dark");

  const cardStyle = {
    ...(!plain && isDarkTheme && { background: "#1e1e2f" }),
    ...(color && { background: color }),
    ...style
  };

  const cardClasses = classNames({
    [classes.card]: true,
    [classes.cardPlain]: plain,
    [classes.cardProfile]: profile,
    [classes.cardChart]: chart,
    [className]: className !== undefined
  });
  return (
    <div className={cardClasses} style={cardStyle} {...rest}>
      {children}
    </div>
  );
}

Card.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  chart: PropTypes.bool,
  style: PropTypes.object,
  theme: PropTypes.object
};

export default withStyles(cardStyle, { withTheme: true })(Card);
